import React, { Component } from 'react'
import { getPageData } from '../utils/helpers'
import { PageWrapper, Hero } from '../components/sections'
import { Testimonials } from '../components'
import HeroImg from '../assets/images/hero-about.jpeg'

class PageAbout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      scrollDiv: 'about-us',
    }
  }

  render() {
    const { scrollDiv } = this.state
    const { data } = this.props
    const wp = getPageData(data, 'About')
    return (
      <PageWrapper page="about">
        <Hero
          page="about"
          data={{
            ...wp,
            hero_background: {
              localFile: {
                childImageSharp: {
                  sizes: {
                    originalImg: HeroImg,
                  },
                },
              },
            },
          }}
          scrollTo={scrollDiv}
        />
        <section className="about-us" id="about-us">
          <div className="about-us__text-top">
            <h2 className="title">What makes us different.</h2>
            <p className="text text--lg">
              No job or project is too big or too small. We offer a professional
              team of operatives that have CSCS, IPAF, City & Guilds and First
              Aid qualifications.
            </p>
          </div>
          <div className="about-us__content">
            <p className="text">
              In the past, we only offered window and gutter cleaning services
              which were carried out in the traditional way (ladder, bucket,
              squeegee and blade). As Health & Safety tightened and technology
              moved on we introduced the Pure Water Reach & Wash System (Hot &
              Cold). This system enables you to carry out your duties with your
              feet firmly on the ground!
            </p>
            <p className="text">
              Reach & Wash opened many different opportunities in the
              commercial/domestic fields. Using this system we can now reach
              windows and different areas we could never get to working from a
              ladder or temporary platforms. As time went on we started cleaning
              schools, offices, blocks of apartments, hospitals etc.
            </p>
          </div>
        </section>
        <section className="why-us">
          <div className="why-us__row">
            <ul className="why-us__reasons">
              <li className="why-us__item">
                <h3 className="title title--sm title--white">
                  Flexible booking
                </h3>
                <p className="text text--white">
                  We always accommodate for our clients, that why we offer
                  flexible booking to your availability.
                </p>
              </li>
              <li className="why-us__item">
                <h3 className="title title--sm title--white">Purified water</h3>
                <p className="text text--white">
                  Mechanically filtered to remove impurities, eliminating the
                  streaks on glass that are often associated with the use of
                  unfiltered water and detergents, as well as environmental
                  benefits.
                </p>
              </li>
            </ul>
            <Testimonials list={wp.testimonials} />
          </div>
        </section>
      </PageWrapper>
    )
  }
}

export default PageAbout

export const queryAboutPage = graphql`
  query aboutPage {
    allWordpressPage {
      edges {
        node {
          slug
          acf {
            page_reference
            hero_title
            hero_text
            hero_background {
              localFile {
                childImageSharp {
                  sizes {
                    originalImg
                  }
                }
              }
            }
            about_us_title
            about_us_large_text
            about_us_text {
              paragraph
            }
            why_us_list {
              title
              text
            }
            testimonials {
              person
              company
              text
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/page-about.js